import type { CriterionScoreRow } from '../types'

interface CriterionScoreBarsProps {
  criteria: CriterionScoreRow[]
}

/** Kriter kırılımı: her satır ad + oransal bar + kazanılan puan + /ağırlık (mockup "critrow"). */
export default function CriterionScoreBars({ criteria }: Readonly<CriterionScoreBarsProps>) {
  const maxPoints = Math.max(1, ...criteria.map((c) => c.points))
  return (
    <div style={{ padding: '8px 22px 16px' }}>
      {criteria.map((c) => (
        <div className="critrow" key={c.name}>
          <span className="cnm">{c.name}</span>
          <div className="cbar">
            <i style={{ width: `${(c.points / maxPoints) * 100}%` }} />
          </div>
          <span className="cval">
            {c.points} <span className="cw">/ {c.weight}</span>
          </span>
        </div>
      ))}
    </div>
  )
}
